import React from 'react'
import styled from 'styled-components'
import { Flex, Text, useModal, Skeleton, HelpIcon, useTooltip } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import BoostFarmModal from 'views/Farms/components/BoostFarmModal'
import BoostCalculatorLink from 'views/Farms/components/BoostCalculatorLink'

const StyledText = styled(Text)`
  cursor: pointer;
`

interface FarmCardActionsProps {
  farmId: number
  boostMultiplier: number
  isBoosted: boolean
  isLoading: boolean
}

const BoostAnotherAction: React.FC<FarmCardActionsProps> = ({
  farmId,
  boostMultiplier = 0,
  isBoosted = true,
  isLoading,
}) => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const [onPresentBoostFarmModal] = useModal(<BoostFarmModal currentFarmId={farmId} />)
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    t('The Boost Factor is the proportion of total rewards compared with the base rewards emitted to the farm.'),
    {
      placement: 'top',
    },
  )

  const clickButton = async () => {
    onPresentBoostFarmModal()
  }
  return isBoosted ? (
    <Flex flexDirection="column" gap="4px">
      <Flex alignItems="center" gap="4px">
        <Text textTransform="uppercase" fontSize="13px" lineHeight="18px">
          {isBoosted ? t('total boost factor') : t('max boost factor')}
        </Text>
        <span ref={targetRef}>
          <HelpIcon width="16px" height="16px" color="primary" mt="4px" />
        </span>
        {tooltipVisible && tooltip}
      </Flex>
      <Flex alignItems="baseline" gap="16px">
        {isLoading || !boostMultiplier ? (
          <Skeleton width="48px" height="36px" />
        ) : (
          <Text fontSize="28px" lineHeight="36px">
            {isBoosted ? boostMultiplier : `~${boostMultiplier}`}x
          </Text>
        )}
        {isBoosted && (
          <StyledText textTransform="capitalize" fontSize="16px" color="primary" bold onClick={clickButton}>
            {t('Boost Another Farm')}
          </StyledText>
        )}
      </Flex>
    </Flex>
  ) : (
    <BoostCalculatorLink color={theme.colors.text} />
  )
}

export default BoostAnotherAction
